import axios from 'axios'
import { fetchAuthSession } from 'aws-amplify/auth'

import { handleMalwareScanBlocked } from './malwareScanResponseHandler'

const axiosClient = axios.create({
    baseURL: '/v2/api',
})

// Surface the malware-scan download gate's 409 as a friendly "still scanning" toast, uniformly.
axiosClient.interceptors.response.use((response) => response, handleMalwareScanBlocked)

// Add a request interceptor
axiosClient.interceptors.request.use(async (config) => {
    const session = await fetchAuthSession()
    const token = session.tokens.idToken

    if (token) {
        config.headers.Authorization = `Bearer ${token}`
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

export default axiosClient
